import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import styles from "./PopoverMenu.module.scss"
import { PopoverContent } from "src/floating/Popover"

/*
 * the PopoverMenu is a specific kind of popover content for offering a menu of options to the user it
 * requires an aria-label for accessibility because it does not explicitly render a label or description
 */
export interface Props extends ComponentPropsWithoutRef<"div"> {
  "aria-label": string;
}

export const PopoverMenu = forwardRef<HTMLDivElement, Props>(
  function PopoverMenu(props: Props, propRef: Ref<HTMLDivElement>) {
    const className = classNames(
      styles.popoverMenu,
      props.className,
    )

    return (
      <PopoverContent
        {...props}
        ref={propRef}
        className={className}
      />
    )
  },
)
